import * as React from 'react';

import {Button} from '../button/button';
import {CloseButton} from '../button/close-button/close-button';
import {Card} from '../card/card';
import {Dialog} from '../dialog/dialog';
import {Body} from '../typography/body';

import styles from './action-card.module.css';

type Props = {
    onAction: () => void;
    onRemove: () => void;
    actionIcon: React.ComponentType<any>;
    actionTitle: string;
    actionSubtitle?: string;
    closeButtonTooltip?: string;
    confirmationQuestion: string;
};

export function ActionCard(props: Props) {
    const Icon = props.actionIcon;
    const [isHovered, setIsHovered] = React.useState<boolean>(false);
    const [isConfirmingRemove, setIsConfirmingRemove] = React.useState<boolean>(false);
    const removeRef = React.useRef<HTMLButtonElement | null | undefined>();

    const handleActionClick = (event: React.SyntheticEvent<any>) => {
        event.preventDefault();
        event.stopPropagation();
        props.onAction();
    };

    const handleRemoveClick = (event: React.SyntheticEvent<any>) => {
        event.preventDefault();
        event.stopPropagation();
        setIsConfirmingRemove(true);
    };

    const handleConfirmRemove = () => {
        props.onRemove();
        setIsConfirmingRemove(false);
    };

    const handleCancelRemove = () => {
        setIsConfirmingRemove(false);
    };

    return (
        <div className='flex justify-sb align-center width-fit-content height-fit-content'>
            <Card
                hasBorder={true}
                hasShadow={false}
                // @ts-expect-error
                preventUnderline={true}
                borderRadius={3}
                fitHeight={true}
                backgroundColor={isHovered ? 'offWhite' : undefined}
            >
                <div className={styles['content-container']}>
                    <div className='flex justify-sb align-center full-width'>
                        <Button
                            variant='text-primary'
                            onClick={handleActionClick}
                            size='normal'
                            icon={Icon}
                            noPadding={true}
                            preventUnderline={true}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            <Body isBold={true} color='dark' size='normal' nowrap={true}>
                                {props.actionTitle}
                            </Body>
                            {props.actionSubtitle && (
                                <Body size='normal' color='medium' truncate={{type: 'block'}}>
                                    {props.actionSubtitle}
                                </Body>
                            )}
                        </Button>
                    </div>
                    <div className={styles['remove-button']}>
                        <CloseButton
                            getRef={(ref) => {
                                removeRef.current = ref;
                            }}
                            onClick={handleRemoveClick}
                            size={16}
                            alignCenter={true}
                            tooltip={props.closeButtonTooltip}
                        />
                    </div>
                </div>
            </Card>
            {isConfirmingRemove && (
                <Dialog
                    anchor={removeRef.current}
                    location='top'
                    question={props.confirmationQuestion}
                    primaryText={'Yes, remove'}
                    secondaryText={'No, don’t remove'}
                    onPrimary={handleConfirmRemove}
                    onSecondary={handleCancelRemove}
                    isWarning={true}
                    customStyles={{width: '240px'}}
                />
            )}
        </div>
    );
}
